import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import logger from "./LoggerFrontend";
import { getDatabase, onDisconnect, onValue, ref, set } from "firebase/database";
import { PROVIDERS, PROVIDERS_TYPE } from "./AuthController.constants";

// Realtime database purposes
import { app } from "./firebaseUtils";
const db = getDatabase(app);

class AuthController {
  constructor() {}
  getAuthInstance() {
    return firebase.auth();
  }

  getCurrentUser() {
    return firebase.auth().currentUser;
  }

  setupUserPresence(user) {
    const presenceRef = ref(db, ".info/connected");
    const userStatusRef = ref(db, `/status/${user.uid}`);
    onValue(presenceRef, (snap) => {
      if (snap.val() === true) {
        set(userStatusRef, { isOnline: true });
        onDisconnect(userStatusRef)
          .set({ isOnline: false })
          .then(() => {
            logger.log("On disconnect setup complete.", "setup to disconnect", {
              user: user.uid
            });
          });
      } else {
        set(userStatusRef, { isOnline: false });
      }
    });
  }

  // Add user presence function
  authStateChanged(cb) {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.setupUserPresence(user);
      }
      logger.debug("AuthController:onAuthStateChanged", "called. userId: ", user && user.uid);
      cb(null, user);
    });
  }

  sendPasswordResetToEmail(email) {
    return new Promise(function (fullfil, reject) {
      firebase.auth().sendPasswordResetEmail(email).then(fullfil).catch(reject);
    });
  }

  getCredentialsWithEmailandPassword(email, password) {
    return firebase.auth.EmailAuthProvider.credential(email, password);
  }

  getCredentials(email, password) {
    return firebase.auth.EmailAuthProvider.credential(email, password);
  }

  createUserWithEmailAndPassword(email, password) {
    return new Promise(function (fullfil, reject) {
      firebase
        .auth()
        .createUserWithEmailAndPassword(email, password)
        .then((user) => {
          fullfil(user);
        })
        .catch(reject);
    });
  }

  logout() {
    return new Promise(function (fullfil, reject) {
      firebase.auth().signOut().then(fullfil).catch(reject);
    });
  }

  signInAnonymously() {
    return new Promise(function (fullfil, reject) {
      firebase
        .auth()
        .signInAnonymously()
        .then((user) => fullfil(user))
        .catch(reject);
    });
  }

  signInWithEmailAndPassword(email, password) {
    return new Promise(function (fullfil, reject) {
      firebase
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then((user) => fullfil(user))
        .catch(reject);
    });
  }

  verifyPasswordResetCode(code) {
    return new Promise(function (fullfil, reject) {
      firebase.auth().verifyPasswordResetCode(code).then(fullfil).catch(reject);
    });
  }

  confirmPasswordReset(code, password) {
    return new Promise(function (fullfil, reject) {
      firebase.auth().confirmPasswordReset(code, password).then(fullfil).catch(reject);
    });
  }

  signInWithPopup(providerType) {
    let provider;
    if (providerType === PROVIDERS_TYPE.GOOGLE) {
      provider = new firebase.auth.GoogleAuthProvider();
    } else if (providerType === PROVIDERS_TYPE.MICROSOFT) {
      provider = new firebase.auth.OAuthProvider(PROVIDERS.MICROSOFT);
    }
    provider.setCustomParameters({ prompt: "select_account" });
    return new Promise(function (fullfil, reject) {
      firebase
        .auth()
        .signInWithPopup(provider)
        .then((result) => {
          fullfil(result);
        })
        .catch(reject);
    });
  }

  linkWithPopup(providerType) {
    let provider;
    if (providerType === PROVIDERS_TYPE.GOOGLE) {
      provider = new firebase.auth.GoogleAuthProvider();
    } else if (providerType === PROVIDERS_TYPE.MICROSOFT) {
      provider = new firebase.auth.OAuthProvider(PROVIDERS.MICROSOFT);
    }
    provider.setCustomParameters({ prompt: "select_account" });
    return new Promise(function (fullfil, reject) {
      firebase
        .auth()
        .currentUser.linkWithPopup(provider)
        .then((result) => {
          fullfil(result);
        })
        .catch(reject);
    });
  }

  unlinkProvider(providerId) {
    return new Promise(function (fullfil, reject) {
      firebase
        .auth()
        .currentUser.unlink(providerId)
        .then((result) => {
          fullfil(result);
        })
        .catch(reject);
    });
  }

  userIsRegistered(uuid) {
    return new Promise(function (resolve, reject) {
      firebase
        .firestore()
        .collection("users")
        .doc(uuid)
        .get()
        .then(function (doc) {
          if (doc.exists) {
            // User exists
            resolve({ uid: doc.id, ...doc.data() });
          } else {
            // User does not exist
            resolve(null);
          }
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  // Function to delete the user's account
  deleteAccount(uuid) {
    var userRef = firebase.auth().currentUser;
    if (userRef && userRef.uid === uuid) {
      userRef
        .delete()
        .then(function () {
          logger.log("User account deleted successfully.");
        })
        .catch(function (error) {
          // An error occurred while deleting the account
          logger.log("Error deleting user account:", { error });
        });
    }
  }

  signOut() {
    return new Promise(function (fullfil, reject) {
      firebase.auth().signOut().then(fullfil).catch(reject);
    });
  }
}

const instance = new AuthController();
//------------------------------------------------------------------------------
// Return instance
//------------------------------------------------------------------------------
export default instance;
